<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		@click:outside="closeDialog"
		@keydown.esc="closeDialog"
		@keydown.enter="setFlags"
	>
		<v-card class="sgnl-pb-4">
			<v-card-title class="dialog-header sgnl-subtitle-medium">
				Set compilation and link flags
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeDialog"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-form
				v-model="formIsValid"
				@submit.prevent="setFlags"
			>
				<v-card-text class="dialog-body stack">
					<div class="input-group">
						<div class="field-label sgnl-text-color-default">Compilation and link flags</div>
						<v-textarea
							v-model="compilationFlags"
							placeholder="e.g. -O2 -Wall -lm"
							:rules="flagRules"
							persistent-hint
							hint="Our platform will pass the compilation and link flags specified above to the compiler when building your application."
						/>
					</div>
				</v-card-text>
				<v-divider />
				<v-card-actions class="dialog-footer">
					<v-btn
						variant="outlined"
						@click="closeDialog"
						>Cancel</v-btn
					>
					<v-btn
						variant="flat"
						color="primary"
						type="submit"
						:disabled="!formIsValid"
					>
						Set Flags
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";

const maxFlagsLength = 100_000;
export default defineComponent({
	name: "CompilationFlagsDialog",
	components: { Close16 },
	props: {
		showDialog: { type: Boolean, default: false },
		initialCompilationFlags: { type: String, default: "" },
	},
	emits: ["close-dialog", "set-flags", "update:showDialog"],
	data: () => ({
		compilationFlags: "",
		maxFlagsLength: maxFlagsLength,
		formIsValid: false,
		flagRules: [
			(value) => {
				const validFlagLength = value.length < maxFlagsLength;
				return validFlagLength || `Maximum compilation flags length allowed is ${maxFlagsLength} characters.`;
			},
		],
	}),
	computed: {
		localShowDialog: {
			get(): boolean {
				return this.showDialog;
			},
			set(value: boolean) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("close-dialog");
		},
		setFlags() {
			this.$emit("set-flags", { compilationFlags: this.compilationFlags });
			this.$posthog?.capture("editor_compilation_flags_set", { has_flags: !!this.compilationFlags?.trim() });
		},
	},
	mounted() {
		this.compilationFlags = this.initialCompilationFlags;
	},
});
</script>
